<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-field>
          <label>输入资源名称</label>
          <md-input v-model="resource.name"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>选择资源文件</label>
          <md-file @change="inputFileChange"/>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-field>
          <label>备注</label>
          <md-input v-model="resource.remark"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item">
        <md-button class="md-raised md-primary" @click="addResource">上传</md-button>
      </div>
    </div>

    <div>
      <md-table>
        <md-table-row>
          <md-table-head class="table_head">名称</md-table-head>
          <md-table-head class="table_head">地址</md-table-head>
          <md-table-head class="table_head">查看</md-table-head>
          <md-table-head class="table_head">备注</md-table-head>
          <md-table-head class="table_head">操作</md-table-head>
        </md-table-row>

        <md-table-row
            v-for="(item) in resources"
            v-bind:key="item.id">
          <md-table-cell>{{ item.name }}</md-table-cell>
          <md-table-cell>{{ item.url }}</md-table-cell>
          <md-table-cell><a v-bind:href="item.url" target="_blank">查看</a></md-table-cell>
          <md-table-cell>{{ item.remark }}</md-table-cell>
          <md-table-cell>
            <md-button class="md-accent" @click="deleteResource(item)">
              删除
            </md-button>
          </md-table-cell>
        </md-table-row>

      </md-table>
    </div>

    <md-dialog :md-active.sync="loading" :md-close-on-esc=false :md-click-outside-to-close=false>
      <div class="md-layout md-alignment-center-center" id="loading_content">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
    </md-dialog>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
  </div>
</template>

<script>
export default {
  name: "ResourceManager",
  data: () => (
      {
        resource: {
          name: '',
          file: null,
          remark: '',
        },
        resources: [],
        loading: false,
        toast: false,
        toastMsg: "",
      }
  ),
  mounted() {
    this.loadResources();
  },
  methods: {
    loadResources: function () {
      this.$http.get('/api/resource/')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.resources = data.data.resources;
                  } else {
                    switch (data.code) {
                      case 3000:
                        this.showErrorTips('当前账号没有权限（3000）');
                        break;
                      default:
                        this.showErrorTips('获取资源列表失败，服务器返回错误码' + data.code);
                        break
                    }
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            if (error.response.status === 403) {
              localStorage.clear();
              this.$router.replace('/login')
            } else {
              this.showErrorTips('未知错误' + error);
            }
          })
    },
    inputFileChange(e) {
      this.resource.file = e.target.files[0]
    },
    addResource: function () {
      if (!this.resource.file) {
        this.showErrorTips('请先选择文件');
        return;
      }
      this.loading = true;
      let postData = new FormData();
      postData.append('resource', this.resource.file);
      postData.append('name', this.resource.name);
      postData.append('remark', this.resource.remark);
      this.$http.post('/api/resource/upload/', postData)
          .then(response => {
            this.loading = false;
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('上传成功');
                this.loadResources();
              } else {
                switch (data.code) {
                  default:
                    this.showErrorTips('上传失败，服务器返回错误码' + data.code);
                    break
                }
              }
            }
          })
          .catch(error => {
            this.loading = false;
            this.showErrorTips('未知错误' + error);
          });
    },
    deleteResource: function (item) {
      this.$http.delete('/api/resource/' + item.id + '/')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.loadResources();
                  } else {
                    switch (data.code) {
                      case 3000:
                        this.showErrorTips('当前账号没有权限（3000）');
                        break;
                      default:
                        this.showErrorTips('获取资源列表失败，服务器返回错误码' + data.code);
                        break
                    }
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            if (error.response.status === 403) {
              localStorage.clear();
              this.$router.replace('/login')
            } else {
              this.showErrorTips('未知错误' + error);
            }
          })
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  }
}
</script>

<style scoped>
.table_head {
  text-align: center;
}

#loading_content {
  padding: 50px 0;
}

.md-layout-item {
  margin-right: 20px;
}
</style>